export default __webpack_public_path__ + "media/images/user_photos/49-63fc498964118ad8f1019f64ab5b7cec.jpg";